import { useMemo } from "react";
import { Dimensions } from "react-native";

export const WINDOW_WIDTH = Dimensions.get("window").width;
export const WINDOW_HEIGHT = Dimensions.get("window").height;

export const useIsDesktop = () => useMemo(() => WINDOW_WIDTH > 1024, []);
